export default "__VITE_ASSET__HPRYTZf1UsRU8iiTZZoweQ__"